<div class="container text-dark pt-4">

  <div class="form-group">
    <input [(ngModel)]="search" class="form-control form-control-lg" type="text" placeholder="search...">
  </div>

  <div class="row d-flex align-items-stretch mb-4">
    <div *ngFor="let product of productList | filter : search" class="col-12 col-md-6 col-lg-4 mt-4">
      <app-product [product]="product"></app-product>
    </div>
  </div>
</div>
